import type { UseQueryResult } from "@tanstack/react-query";
import * as React from "react";

import { Skeleton } from "./skeleton";

type QueryViewProps<TData, TError = Error> = {
  query: UseQueryResult<TData, TError>;
  loading?: React.ReactNode;
  error: (err: TError) => React.ReactNode;
  empty?: React.ReactNode;
  isEmpty?: (data: TData) => boolean;
  children: (data: TData) => React.ReactNode;
};

function DefaultLoading() {
  return (
    <div data-slot="query-view-loading" className="space-y-2" aria-busy="true">
      <Skeleton className="h-4 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
    </div>
  );
}

function QueryView<TData, TError = Error>({
  query,
  loading,
  error,
  empty,
  isEmpty,
  children,
}: QueryViewProps<TData, TError>) {
  if (query.isPending) return <>{loading ?? <DefaultLoading />}</>;
  if (query.isError) return <>{error(query.error)}</>;
  const data = query.data;
  if (empty !== undefined && (isEmpty ? isEmpty(data) : data == null)) {
    return <>{empty}</>;
  }
  return <>{children(data)}</>;
}

export { QueryView };
export type { QueryViewProps };
